// extracted by mini-css-extract-plugin
var _1 = "styles-module__halfPageContainer--aKqKN";
var _2 = "styles-module__halfPageWrapper--rEBI8";
var _3 = "styles-module__page--DRCMB";
export { _1 as "halfPageContainer", _2 as "halfPageWrapper", _3 as "page" }
